export default function toc() {
    // TOC change chevron on hover
    let tocContainer = document.querySelector("#toc_container");
    let toggleBtn = document.querySelector(".ctoc-toggle");

    if (tocContainer && toggleBtn) {
        toggleBtn.addEventListener("mouseenter", function () {
            tocContainer.classList.add("hovered");
        });

        toggleBtn.addEventListener("mouseleave", function () {
            tocContainer.classList.remove("hovered");
        });
    }

    let tocItems = document.querySelectorAll(".ctoc__item");

    if (tocItems) {
        tocItems.forEach(item => {
            let parentLi = item.closest("li");
            let nestedOl = parentLi.querySelector("ol");
            let existingLink = parentLi.querySelector("a");

            if (nestedOl && existingLink) {
                nestedOl.style.display = "none";

                existingLink.classList.add("ctoc__item-link");

                existingLink.addEventListener("click", function (event) {
                    event.stopPropagation();

                    if (nestedOl.style.display === "none") {
                        nestedOl.style.display = "block";
                        existingLink.classList.add("ctoc__item-link--active");
                    } else {
                        nestedOl.style.display = "none";
                        existingLink.classList.remove("ctoc__item-link--active");
                    }
                });
            }
        });
    }
}